/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {AlertController, NavParams} from 'ionic-angular';
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";

//和dialing下级返点编辑样式一致
@Component({
  templateUrl: 'agentAutoRegEdit.html',
  selector: 'agent-auto-reg-edit-page',
})
export class AgentAutoRegEditPage {
  pointssc: number = 0.0;
  // point115: number = 0.0;
  // pointdp: number = 0.0;
  sign:string;
  selssc: any = [];
  // sel115: any = [];
  // seldp: any = [];

  constructor(private navParams: NavParams, private alertCtrl: AlertController, private userService: UserService) {
    let data = navParams.get("initData");
    let item = navParams.get("item");
    this.pointssc = item.pointssc/100;
    // this.point115 = item.point115/100;
    // this.pointdp = item.pointdp/100;
    this.selssc = data["pointssc"];
    // this.sel115 = data["point115"];
    // this.seldp = data["pointdp"];
    this.sign= item["sign"];
  }

  submitFn() {
    let requestData: any = {
      rpointssc: this.pointssc,
      // rpoint115: this.point115,
      // rpointdp: this.pointdp,
      sign:this.sign
    };

    this.userService.agentAutoRegEdit(requestData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: "Cập nhật thành công."
        });
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/agentAutoRegEdit/agentAutoRegEdit.ts